

























































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { 
  MonthlyIncomeReport,
  FormLabelAlign,
} from '@/store/pages/report/index.d';
import { 
  initReportData,
  fetchReport,
  sortChange,
  renderHeader,
  styleCal,
  cellClick,
  saveBenchmarks,
} from '@/utils/report';
import BenchmarksDialog from './BenchmarksDialog.vue';
const Report = namespace('report');

@Component({
  components: {
    BenchmarksDialog,
  },
})
export default class MIRContent extends Vue {
  @Prop() private reportId!: number;
  @Prop() private level!: number;
  @Prop() private start!: Date | string;
  @Prop() private end!: Date | string;
  @Prop() private loading!: boolean;

  @Report.Getter('monthlyIncomeReport') private monthlyIncomeReport!: MonthlyIncomeReport;
  @Report.Action('getMonthlyIncomeReport') private getMonthlyIncomeReport: any;
  @Report.Action('saveMonthlyIncomeReportBenchmarks') private saveMonthlyIncomeReportBenchmarks: any;
  
  // 表单相关
  private sort_field_id: number = 1;
  private fileds: number = 1;
  private sort_order: number = 2;
  private store_group_id: number | null = null;
  private property: string = '';
  private label: string = '';
  // 分页相关
  private pageSize: number = 10;
  private currentPage: number = 1;
  // 弹窗相关
  private dialogSettingTableVisible: boolean = false;
  private formLabelAlign: FormLabelAlign = {
    value1: null,
    value2: null,
    value3: null,
  };
  // router history
  private config: any = {};

  public mounted() {
    initReportData(this, 'getMonthlyIncomeReport', 'monthlyIncomeReport');
  }
  public fetchReport(params: any) {
    fetchReport(this, 'getMonthlyIncomeReport', params);
  }
  public handleSizeChange(val: number) {
    this.pageSize = val;
    this.currentPage = 1;
    this.fetchReport({});
  }
  public handleCurrentChange(val: number) {
    this.currentPage = val;
    this.fetchReport({});
  }
  public sortChange(params: any) {
    sortChange(this, 'monthlyIncomeReport', params);
  }
  public renderHeader(h: any, {column, $index}: any) {
    return renderHeader(this, 'monthlyIncomeReport', h, {column, $index});
  }
  public styleCal( row: any, name: string, value: number ) {
    return styleCal(this, 'monthlyIncomeReport', row, name, value);
  }
  public cellClick(row: any, column: any, cell: any) {
    cellClick(this, 'monthlyIncomeReport', row, column, cell, false);
  }
  public changedialog(bool: boolean) {
    this.dialogSettingTableVisible = bool;
  }
  public saveBenchmarks(benchmarks: any) {
    saveBenchmarks(this, 'saveMonthlyIncomeReportBenchmarks', 'monthlyIncomeReport', benchmarks);
  }
}
